export default __webpack_public_path__ + "static/media/table-mobile@3x.6288fc9f.png";